import axios from 'axios';
import { API_KEY } from '../../../src/config.js';

const apiKey = atob(API_KEY); // Decodifica a chave base64

// Envia e-mail genérico (fale conosco ou proposta simples)
const enviarEmailSuporte = async (mensagem, nome, telefone, email, modulos) => {
  let sentEmail = false;

  await axios
    .post(
      'https://api.sendinblue.com/v3/smtp/email',
      {
        sender: { name: 'KonsistMed', email: 'financeiro@konsist.com.br' },
        to: [
          { email: 'suporte@konsist.com.br' },
          { email: 'konsist@konsist.com.br' },
          { email: 'financeiro@konsist.com.br' },
        ],
        subject: `${
          Array.isArray(modulos)
            ? 'Proposta enviada para: ' + nome
            : 'Fale Conosco: ' + nome
        }`,
        htmlContent: `<html><body><div>
            <p><strong>Nome:</strong> ${nome}</p>
            <p><strong>Telefone:</strong> ${telefone}</p>
            <p><strong>Email:</strong> ${email}</p>
            <p><strong>Mensagem:</strong><br>${mensagem}</p>
          </div></body></html>`,
      },
      {
        headers: {
          'api-key': apiKey,
          'Content-Type': 'application/json',
        },
      },
    )
    .then((response) => {
      console.log('E-mail enviado com sucesso!', response.status);
      if (response.status === 201) {
        sentEmail = true;
      }
    })
    .catch((error) => {
      console.error('Erro ao enviar e-mail', error);
    });

  return sentEmail;
};

// Envia e-mail de proposta com templateId (caso use Sendinblue Templates)
const enviarEmailProposta = async (nome, email, modulos) => {
  try {
    const response = await fetch('https://api.sendinblue.com/v3/smtp/email', {
      method: 'POST',
      headers: {
        'api-key': apiKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sender: {
          name: 'Konsist',
          email: 'financeiro@konsist.com.br',
        },
        to: [
          {
            email: email,
            name: nome,
          },
        ],
        templateId: 1, // ID do template cadastrado no Sendinblue
        params: {
          NOME: nome,
        },
      }),
    });

    return response.status === 201;
  } catch (error) {
    console.error('Erro ao enviar proposta:', error);
    return false;
  }
};

// Envia e-mail com os dados do contrato
const enviarEmailContrato = async (dados) => {
  const {
    razaoSocial,
    nomeFantasia,
    documento,
    inscricaoEstadual,
    email,
    emailRepresentante,
    endereco,
    cidade,
    uf,
    cep,
    telefone,
    representante,
    nascimentoRepresentante,
    cpfRepresentante,
    cargo,
    testemunhaNome,
    testemunhaNascimento,
    testemunhaCpf,
    testemunhaEmail,
    modulosSelecionados,
  } = dados;

  const modulos = Object.entries(modulosSelecionados)
    .filter(([key, value]) => {
      // Filtra os módulos booleanos que estão true
      if (typeof value === 'boolean') return value === true;
      // Para a migração, só inclui se for "sim"
      if (key === 'migracao') return value === 'sim';
      return false;
    })
    .map(([key]) => {
      switch (key) {
        case 'atendimento':
          return 'Atendimento';
        case 'faturamento':
          return 'Faturamento';
        case 'nfse':
          return 'NFS-e';
        case 'estoque':
          return 'Estoque';
        case 'financeiro':
          return 'Financeiro';
        case 'agendaWeb':
          return 'Agenda WEB';
        case 'whatsapp':
          return 'Envio de Mensagem WhatsApp';
        case 'hospedagem':
          return 'Hospedagem em Nuvem';
        case 'migracao':
          return 'Migração de outro sistema';
        default:
          return '';
      }
    });

  function formatarDataParaBrasileiro(data) {
    if (!data) return '';
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  const hospedagemInfo = modulosSelecionados.hospedagemInfo || 'Não informado';
  const migracaoInfo = modulosSelecionados.migracaoInfo || 'Não informado';

  const corpoEmail = `
    <h2>Dados para Contrato</h2>
    <p><strong>Razão Social:</strong> ${razaoSocial}</p>
    <p><strong>Nome Fantasia:</strong> ${nomeFantasia}</p>
    <p><strong>Documento:</strong> ${documento}</p>
    <p><strong>Inscrição Estadual:</strong> ${inscricaoEstadual}</p>
    <p><strong>Email:</strong> ${email}</p>
    <p><strong>Endereço:</strong> ${endereco}, ${cidade} - ${uf}, CEP: ${cep}</p>
    <p><strong>Telefone:</strong> ${telefone}</p>

    <h3>Representante Legal</h3>
    <p><strong>Nome:</strong> ${representante}</p>
    <p><strong>Email Representante:</strong> ${emailRepresentante}</p>
    <p><strong>Nascimento Representante:</strong> ${formatarDataParaBrasileiro(
      nascimentoRepresentante,
    )}</p>
    <p><strong>CPF Representante:</strong> ${cpfRepresentante}</p>
    <p><strong>Cargo Representante:</strong> ${cargo}</p>

    <h3>Testemunha</h3>
    <p><strong>Nome:</strong> ${testemunhaNome}</p>
    <p><strong>Email Testemunha:</strong> ${testemunhaEmail}</p>
    <p><strong>Nascimento Testemunha:</strong> ${formatarDataParaBrasileiro(
      testemunhaNascimento,
    )}</p>
    <p><strong>CPF Testemunha:</strong> ${testemunhaCpf}</p>

    <h3>Módulos Contratados</h3>
    <ul>${modulos.map((m) => `<li>${m}</li>`).join('')}</ul>

    ${
      modulosSelecionados.hospedagem
        ? `<p><strong>Informações da Hospedagem:</strong> ${hospedagemInfo}</p>`
        : ''
    }
    ${
      modulosSelecionados.migracao === 'sim' && modulosSelecionados.migracaoInfo
        ? `<p><strong>Informações da Migração:</strong> ${migracaoInfo}</p>`
        : ''
    }
  `;

  try {
    const response = await fetch('https://api.sendinblue.com/v3/smtp/email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'api-key': apiKey,
      },
      body: JSON.stringify({
        sender: { name: 'Formulário', email: 'financeiro@konsist.com.br' },
        to: [
          { email: 'financeiro@konsist.com.br' },
          { email: 'comercial@konsist.com.br' },
          { email: 'andresteindasilva@gmail.com' },
        ],
        subject: `Novo formulário de contrato: ${razaoSocial} - ${documento}`,
        htmlContent: corpoEmail,
      }),
    });

    return response.ok;
  } catch (err) {
    console.error('Erro ao enviar e-mail:', err);
    return false;
  }
};

export default {
  enviarEmailSuporte,
  enviarEmailProposta,
  enviarEmailContrato,
};
